import React, { Component } from 'react';
import Topnavbar from '../components/topnavbar/Topnavbar'
import Aboutshome from '../components/Aboutshome/Aboutshome'
import Event from '../components/Event/Event'
import Recentprojects from '../components/Recentprojects/Recentprojects'
import Team from '../components/Team/Team'
import Footer from '../components/Footer/Footer'
import Gallery from '../components/Gallery/Gallery'
import Topbanner from '../components/Topbanner/Topbanner';
import Videogallery from '../components/Videogallery/Videogallery';
import CompanyTrust from '../components/CompanyTrust/CompanyTrust';
import AnnualReports from '../components/AnnualReports/AnnualReports';
import DonateSection from '../components/DonateSection/DonateSection';
import JoinCommunity from '../components/JoinCommunity/JoinCommunity';
import Testimonials from '../components/Testimonials/Testimonials';

// Section Divider Component
const SectionDivider = () => (
    <div className="relative w-full py-2">
        {/* Simple elegant line with meaningful accent */}
        <div className="flex justify-center items-center">
            {/* Left line */}
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-blue-300"></div>
            
            {/* Center meaningful symbol */}
            <div className="mx-3 flex items-center">
                <div className="w-1 h-1 bg-blue-600 rounded-full"></div>
                <div className="w-0.5 h-0.5 bg-blue-400 rounded-full mx-0.5"></div>
                <div className="w-1 h-1 bg-blue-600 rounded-full"></div>
            </div>
            
            {/* Right line */}
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-blue-300"></div>
        </div>
    </div>
);

class Homepage extends Component {
    componentDidMount(){
        window.scroll(0,0)
    }
    render() {
        return (
            <div>
                <Topnavbar/>
                <Topbanner/>
                <Aboutshome/>
                <SectionDivider />
                <Event/>
                
                <Recentprojects/>
                <SectionDivider />
                <JoinCommunity/>
                <SectionDivider />
                <Gallery/>
                <SectionDivider />
                <Testimonials/>
                <SectionDivider />
                <Videogallery/>
                <SectionDivider />
                <AnnualReports/>
                <SectionDivider />
                <CompanyTrust/>
                <SectionDivider />
                {/* DonateSection hidden until payment goes live */}
                {false && <DonateSection/>}

                <Team/>
                <SectionDivider />
                <Footer/>
            </div>
        );
    }
}

export default Homepage;






